import Axhelper from '@/lib/Axhelper'

const normalizeTraining = training => {
	if (!training || typeof training !== 'object') return training

	return {
		...training,
		nazwa: training.nazwa || training.trainingName || '',
		placowkaName: training.placowkaName || training.PlacowkaName || '',
		data_rozpoczecia: training.data_rozpoczecia || training.trainingDate || '',
		data_zakonczenia: training.data_zakonczenia || training.trainingEndDate || training.data_rozpoczecia || '',
		status: training.status || '',
	}
}

class MojeSzkoleniaService {
	constructor() {
		this.endpoints = {
			myTrainings: '/api/szkolenia/mytrainings',
		}
	}

	async getAll(options = {}) {
		try {
			const {
				limit = 50,
				sortColumn = 'data_rozpoczecia',
				sortDirection = 'desc',
				filters = {},
			} = options

			const params = this._buildParams({ limit, sortColumn, sortDirection, filters })
			const url = `${this.endpoints.myTrainings}?${params.toString()}`
			const response = await Axhelper.sendGetAsync(url)

			if (response.error) {
				return {
					data: [],
					error: response.error,
					totalCount: 0,
					hasMore: false,
				}
			}

			return this._buildListResponse(response)
		} catch (error) {
			console.error('MojeSzkoleniaService.getAll error:', error)
			return {
				data: [],
				error: error.message || 'Failed to fetch my trainings',
				totalCount: 0,
				hasMore: false,
			}
		}
	}

	async search(searchTerm, options = {}) {
		try {
			const trimmed = (searchTerm || '').trim()
			if (!trimmed) {
				return {
					data: [],
					error: 'Invalid search term provided',
					totalCount: 0,
					hasMore: false,
				}
			}

			const {
				limit = 50,
				sortColumn = 'data_rozpoczecia',
				sortDirection = 'desc',
				filters = {},
			} = options

			const params = this._buildParams({ limit, sortColumn, sortDirection, filters })
			const url = `${this.endpoints.myTrainings}?searchText=${encodeURIComponent(trimmed)}&${params.toString()}`
			const response = await Axhelper.sendGetAsync(url)

			if (response.error) {
				return {
					data: [],
					error: response.error,
					totalCount: 0,
					hasMore: false,
				}
			}

			return this._buildListResponse(response)
		} catch (error) {
			console.error('MojeSzkoleniaService.search error:', error)
			return {
				data: [],
				error: error.message || 'Failed to search my trainings',
				totalCount: 0,
				hasMore: false,
			}
		}
	}

	_buildParams({ limit, sortColumn, sortDirection, filters }) {
		const params = new URLSearchParams({
			sortcol: sortColumn,
			sortdir: sortDirection,
			limit: String(limit),
		})

		if (filters?.status) {
			params.append('status', String(filters.status))
		}
		if (filters?.placowkaId) {
			params.append('placowkaId', String(filters.placowkaId))
		}

		return params
	}

	_buildListResponse(response) {
		const rows = (Array.isArray(response.data) ? response.data : []).map(normalizeTraining)
		const totalCount = response.headers?.['x-total-count']
			? parseInt(response.headers['x-total-count'], 10)
			: rows.length

		return {
			data: rows,
			error: null,
			totalCount,
			hasMore: rows.length < totalCount,
			headers: response.headers,
		}
	}
}

export default new MojeSzkoleniaService()
